// useLoginData.js
import { useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";

export function useLoginData() {
  const { userProfileData } = useSelector((state) => state.profile);

  // fallback to secureLocalStorage if redux data is empty
  const userData =
    userProfileData ||
    secureLocalStorage.getItem(process.env.REACT_APP_USER_STORAGE_KEY);

  return userData?.data;
}
